import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=918ae6de&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918ae6de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('918ae6de')) {
      api.createRecord('918ae6de', component.options)
    } else {
      api.reload('918ae6de', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=918ae6de&scoped=true&", function () {
      api.rerender('918ae6de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4yC5S69HmQtDt/JS/comp/Voucher-Unit.vue"
export default component.exports